import {
  Dialog,
  DialogContainer,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Spinner,
} from "@dust-tt/sparkle";
// biome-ignore lint/correctness/noUnusedImports: ignored using `--suppress`
import React from "react";
import { useTranslation } from "react-i18next";

type LeaveConversationDialogProps = {
  isOpen: boolean;
  isLeaving?: boolean;
  onClose: () => void;
  onLeave: () => void;
};

export const LeaveConversationDialog = ({
  isLeaving,
  onLeave,
  onClose,
  isOpen,
}: LeaveConversationDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("conv.leaveConversationDialogTitle", "Leave conversation")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "common.leaveConversationConfirm",
              "Are you sure you want to leave this conversation?"
            )}
          </DialogDescription>
        </DialogHeader>
        {isLeaving ? (
          <div className="flex justify-center py-8">
            <Spinner variant="dark" size="md" />
          </div>
        ) : (
          <>
            <DialogContainer>
              <b>
                {t(
                  "common.leaveConversationBody",
                  "You will no longer have access to this conversation."
                )}
              </b>
            </DialogContainer>
            <DialogFooter
              leftButtonProps={{
                label: t("conv.cancel", "Cancel"),
                variant: "outline",
              }}
              rightButtonProps={{
                label: t("conv.leave", "Leave"),
                onClick: async () => {
                  await onLeave();
                  onClose();
                },
              }}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
